/* @ngInject */
function ReactionBarController ($scope, $timeout, $translate, EmojisService, Utils, PostsService, ToastService, SegmentService) {
  $scope.reactions = []
  $scope.emojisDataReaction = []

  $scope.selectedRate = null
  $scope.postReactionEmojiCode = null

  $scope.totalRatingAverage = 0

  $scope.maxRate = 5

  const api = {
    _markEmojiAsSelected,
    _getNumberRatingByEmoji,
    _reactToPost,
    _getAverageByUsers
  }

  this.getApi = () => api

  activate()

  function activate () {
    EmojisService.getEmojis([
      'DISAPPOINTED',
      'NEUTRAL',
      'GRINNING'
    ]).then(emojis => {
      $scope.reactions = Utils.mapPropertyToSafeValue(emojis, 'code')
    })

    $timeout(() => {
      $scope.postReactionEmojiCode = $scope.post?.postReactions?.emojiCode

      if ($scope.usersRead?.length) {
        const usersWithRating = $scope.usersRead.filter(user => user.userRating)
        $scope.totalRatingAverage = api._getAverageByUsers(usersWithRating)
      }
    }, 500, true)
  }

  $scope.$watch('readersData', (newValue = []) => {
    $scope.emojisDataReaction = newValue.map(val => {
      return Object.assign(val, {
        users: $translate.instant('usersCount', {
          number: val.users
        })
      })
    })
  })

  $scope.$watch('post.postReactions.emojiCode', (newValue) => {
    if (newValue) {
      $scope.postReactionEmojiCode = newValue
    }
  })

  const deregisterRatingStarsChangedValue = $scope.$on('ratingStars-changed-value', (_, event) => {
    if (event) {
      $scope.selectedRate = event.value

      $scope.reactToPost('STAR')
    }
  })

  $scope.$on('$destroy', () => {
    deregisterRatingStarsChangedValue()
  })

  $scope.reactToPost = function (reactType, reaction, event) {
    const post = $scope.post
    const postId = post.id

    if (post.postReactions) {
      return
    }

    if (reactType === 'EMOJI') {
      event.stopPropagation()
      event.stopImmediatePropagation()

      $scope.postReactionEmojiCode = reaction.code

      const reactOptions = {
        rating: api._getNumberRatingByEmoji(reaction.name)
      }

      const eventOptions = {
        post_id: post.id,
        rating: reaction.name,
        rating_type: post.trackReactions
      }

      api._reactToPost(
        postId,
        reactOptions,
        eventOptions
      )
    }

    if (reactType === 'STAR') {
      const reactOptions = {
        rating: $scope.selectedRate
      }

      const eventOptions = {
        post_id: post.id,
        rating: $scope.selectedRate,
        rating_type: post.trackReactions
      }

      api._reactToPost(
        postId,
        reactOptions,
        eventOptions,
        () => api._markEmojiAsSelected.bind(this, reaction)
      )
    }
  }

  function _markEmojiAsSelected (reaction) {
    if (!$scope.post.postReactions) {
      $scope.post.postReactions = {
        emojiCode: reaction.code,
        emojiName: reaction.name
      }

      return
    }

    $scope.post.postReactions.emojiCode = reaction.code
    $scope.post.postReactions.emojiName = reaction.name
  }

  function _getNumberRatingByEmoji (emojiName) {
    const emojiNames = {
      DISAPPOINTED: 1,
      NEUTRAL: 3,
      GRINNING: 5
    }

    return emojiNames[String(emojiName)]
  }

  function _reactToPost (postId, reactOptions, eventOptions, callbackFn = () => {}) {
    PostsService.reactToPost(postId, reactOptions)
      .then(() => {
        callbackFn()
        SegmentService.track('rated-announcement', eventOptions)
      })
      .catch(ToastService.defaultErrorToast)
  }

  function _getAverageByUsers (usersRead) {
    if (!usersRead.length) return 0

    const sum = usersRead.reduce((acc, item) => acc + item.userRating, 0)
    const average = sum / usersRead.length

    return Number(average.toFixed(1))
  }
}

export { ReactionBarController }
